module.exports = __webpack_public_path__ + "assets/img/block-right-b8dd96f1.png";